import React, {Component} from "react";

export default class Loading extends Component {

    componentDidMount() {
    }

    render() {
        return (
            this.props.show ?
                (<div className="lds-ellipsis">
                    <div className="contain-loading">
                        <div className={this.props.colorful ? "black" : ""}/>
                        <div className={this.props.colorful ? "black" : ""}/>
                        <div className={this.props.colorful ? "black" : ""}/>
                        <div className={this.props.colorful ? "black" : ""}/>
                    </div>
                </div>) : (this.props.children)
        );
    }
}
